"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XMLViewer = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireWildcard(require("query-string"));

var _reactScroll = require("react-scroll");

var _xpath = _interopRequireDefault(require("xpath"));

var cheerio = _interopRequireWildcard(require("cheerio"));

var _layout = _interopRequireDefault(require("../../layout"));

var _components = require("../../components");

var _BodySection = _interopRequireDefault(require("../CDAMainViewer/BodySection"));

var _useScrollToTop = _interopRequireDefault(require("../../lib/utils/hooks/useScrollToTop"));

var _Global = _interopRequireDefault(require("../../styles/Global.style"));

var XMLViewer = function XMLViewer(_ref) {
  var data = _ref.data,
      rawData = _ref.rawData,
      documentTitle = _ref.documentTitle;

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 2),
      searchParams = _useSearchParams2[0],
      setSearchParams = _useSearchParams2[1];

  var match = (0, _reactRouterDom.useMatch)();
  var navigate = (0, _reactRouterDom.useNavigate)();

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      rowsToExport = _useState2[0],
      setRowsToExport = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      resetRows = _useState4[0],
      setResetRows = _useState4[1];

  (0, _useScrollToTop.default)();

  var _setSearchParams = function _setSearchParams(section, suggestion) {
    if (section !== 'Sections') {
      var regex = /[\(\)']+/g;
      var selectorArr = suggestion.replace(regex, '|').split('|');
      var selector = selectorArr[selectorArr.length - 2];
      var searchString = suggestion;

      var params = _queryString.default.parse(searchParams.toString());

      var queryParams = new URLSearchParams(searchParams);
      queryParams.delete('section');
      queryParams.delete('selector');
      queryParams.delete('searchString');
      queryParams.delete('search');
      navigate({
        search: queryParams.toString()
      }, {
        replace: true
      });
      navigate({
        search: params.attachment ? "".concat(searchParams.toString(), "&section=").concat(section, "&selector=").concat(selector, "&searchString=").concat(searchString) : "?section=".concat(section, "&selector=").concat(selector, "&searchString=").concat(searchString)
      }, {
        replace: true
      });
    }
  };

  function isNumeric(str) {
    if (typeof str != 'string') return false; // we only process strings!

    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
  }

  var convertXpathToSearchValue = function convertXpathToSearchValue(xpathString) {
    console.log('[convertXpathToSearchValue] xpathString: ', xpathString);
    if (!xpathString || typeof xpathString !== 'string') return;
    var xmlDocumentDom = new DOMParser().parseFromString(rawData, 'text/xml');

    var select = _xpath.default.useNamespaces({
      ns1: 'urn:hl7-org:v3'
    }); // Example:
    // From: (//section[code[@code='11450-4']]/entry)[12]/act/entryRelationship[@typeCode='SUBJ']/observation/value
    // To: (//ns1:section[ns1:code[@code='11450-4']]/ns1:entry)[12]/ns1:act/ns1:entryRelationship[@typeCode='SUBJ']/ns1:observation/ns1:value


    var xPathNameSpaceAfterDoubleSlash = xpathString.replace(/(\/\/)/g, '//ns1:');
    var xPathNamespaceAfterEverySlash = '';

    for (var i = 0; i < xPathNameSpaceAfterDoubleSlash.length; i++) {
      var _match = xPathNameSpaceAfterDoubleSlash[i].match(/(\/)/);

      if (_match && xPathNameSpaceAfterDoubleSlash[i - 1] !== '/' && xPathNameSpaceAfterDoubleSlash[i + 1] !== '/') {
        xPathNamespaceAfterEverySlash += '/ns1:';
      } else {
        xPathNamespaceAfterEverySlash += xPathNameSpaceAfterDoubleSlash[i];
      }
    }

    var xPathNamespaceAfterBracket = '';

    for (var _i = 0; _i < xPathNamespaceAfterEverySlash.length; _i++) {
      var _match2 = xPathNamespaceAfterEverySlash[_i].match(/\[/);

      if (_match2 && xPathNamespaceAfterEverySlash[_i + 1] !== '@' && !isNumeric(xPathNamespaceAfterEverySlash[_i + 1])) {
        xPathNamespaceAfterBracket += '[ns1:';
      } else {
        xPathNamespaceAfterBracket += xPathNamespaceAfterEverySlash[_i];
      }
    }

    var finalXpathString = xPathNamespaceAfterBracket;
    console.log('finalXpathString: ', finalXpathString);
    var foundNodes = select(finalXpathString, xmlDocumentDom);
    console.log('foundNodes: ', foundNodes);
    var searchString;

    if (foundNodes.length) {
      var valueString = foundNodes[0].outerHTML;
      console.log('valueString: ', valueString);
      var valueNode = cheerio.load(valueString, {
        xml: {
          xmlMode: true
        }
      });
      var referenceValue = valueNode('reference').attr('value');
      console.log('referenceValue: ', referenceValue);

      if (referenceValue) {
        if (referenceValue.startsWith('#')) {
          referenceValue = referenceValue.slice(1);
        }

        console.log('[convertXpathToSearchValue] referenceValue: ', referenceValue);
        var clinicalDocument = cheerio.load(rawData, {
          xml: {
            xmlMode: true
          }
        });
        searchString = clinicalDocument("[ID=".concat(referenceValue, "]")).text();
        console.log('[convertXpathToSearchValue] searchString: ', searchString);
      } else {
        var translationValue = valueNode('translation').attr('displayName');
        var valueAttr = valueNode('value').attr('displayName');
        searchString = translationValue ? translationValue : valueAttr;
      }

      return searchString;
    }
  };

  (0, _react.useEffect)(function () {
    var params = (0, _queryString.parse)(searchParams.toString());

    if (params.section) {
      _reactScroll.scroller.scrollTo(params.section);
    }

    if (params.search) {
      var xpathString = params.search;
      var searchValue = convertXpathToSearchValue(xpathString);

      if (searchValue) {
        var filteredData = {};
        data.searchData.forEach(function (suggestion) {
          var _filteredData$suggest;

          filteredData[suggestion.groupTitle] = [];
          var sortData = suggestion.data.filter(function (i) {
            if (typeof i === 'string') {
              var startCondition = i.toLowerCase().startsWith(searchValue.toLowerCase()),
                  includeCondition = i.toLowerCase().includes(searchValue.toLowerCase());

              if (startCondition) {
                return startCondition;
              } else if (!startCondition && includeCondition) {
                return includeCondition;
              } else {
                return null;
              }
            }

            return null;
          }).slice(0, 1);

          (_filteredData$suggest = filteredData[suggestion.groupTitle]).push.apply(_filteredData$suggest, (0, _toConsumableArray2.default)(sortData));
        });
        Object.keys(filteredData).some(function (category, i) {
          if (filteredData[category].length) {
            _setSearchParams(category, filteredData[category][0]);

            _reactScroll.scroller.scrollTo(category, {
              smooth: true,
              duration: 1000
            });

            return true;
          } else {
            return false;
          }
        });
      }
    }
  }, []); // if (!data || !rawData) {
  //   navigate({
  //     pathname: '/',
  //     state: { from: match.pathname }
  //   });
  // }

  var header = data.header,
      body = data.body;

  var resetRowsSelection = function resetRowsSelection() {
    setRowsToExport([]);
    setResetRows(true);
    setTimeout(function () {
      setResetRows(false);
    }, 500);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Global.default, null), /*#__PURE__*/_react.default.createElement(_layout.default, {
    currentDocument: data,
    rowsToExport: rowsToExport,
    resetRowsSelection: resetRowsSelection,
    rawDocument: rawData,
    documentTitle: documentTitle
  }, /*#__PURE__*/_react.default.createElement(_components.DocumentHeader, {
    documentHeaderData: header
  }), body && body.map(function (section, i) {
    return /*#__PURE__*/_react.default.createElement(_BodySection.default, {
      key: i,
      section: section,
      setRowsToExport: setRowsToExport,
      resetRows: resetRows,
      currentDocument: data,
      rawDocument: rawData
    });
  })));
};

exports.XMLViewer = XMLViewer;